import { render, staticRenderFns } from "./RoleUpdate.vue?vue&type=template&id=0745e1d2&"
import script from "./RoleUpdate.vue?vue&type=script&lang=ts&"
export * from "./RoleUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports